import { GraphQLResult } from "@aws-amplify/api-graphql";
import { API, graphqlOperation } from "aws-amplify";
import { updateMonitorCheckResult } from "graphql/mutations";
import { listMonitorCheckResultBySubjectId } from "graphql/queries";
import {
  ListMonitorCheckResultBySubjectIdQuery,
  MonitorCheckResult,
  MonitorCheckResultType,
} from "types/graphqlapi";

export const listMonitorCheckResultBySubjectIdQuery = async (
  subjectId: string
) => {
  let list: MonitorCheckResult[] = [];
  let nextToken = null;

  do {
    const result = (await API.graphql(
      graphqlOperation(listMonitorCheckResultBySubjectId, {
        subject_id: subjectId,
        limit: 100,
        nextToken,
      })
    )) as {
      data: ListMonitorCheckResultBySubjectIdQuery;
    };
    const data = result.data.listMonitorCheckResultBySubjectId;
    const items = (data?.items || []) as MonitorCheckResult[];

    nextToken = data?.nextToken;

    list = [...list, ...items];
  } while (nextToken);

  return list;
};

export const updateMonitorCheckResultMutation = async (
  monitorCheckResultId: string
) => {
  const updateMonitorCheckResultInput = {
    input: {
      id: monitorCheckResultId,
      monitor_check_result_type: MonitorCheckResultType.FIXED,
    },
  };

  const result = (await API.graphql(
    graphqlOperation(updateMonitorCheckResult, updateMonitorCheckResultInput)
  )) as GraphQLResult<{ updateMonitorCheckResult: MonitorCheckResult }>;

  return result.data?.updateMonitorCheckResult;
};
